import { LoaderCircle } from "lucide-react"

const LoadingContent = () => {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <LoaderCircle className="animate-spin" size={32} />
        </div>
    )
}

export default LoadingContent